import type {
  PaginationInterface,
  ProductsLimitsFilters,
} from '@app/pages/Warehouses/PurchasePlanningSettings/types';

export const PF = 'purchase-planning-settings';

export const initialPagination: PaginationInterface = {
  itemsPerPage: 20,
  page: 1,
  total: 0,
};

export const initialFilters: ProductsLimitsFilters = {
  warehouseId: 0,
  search: '',
  categories: [],
};
